import React from "react"
import {Navigate} from 'react-router-dom'
import useAuth from "./useAuth"

export default function AdminRoute({children}) {

    const {loggedIn, admin, loading} = useAuth()
    
    if (loading) return
    
    if (!(loggedIn && admin)) {
        return <Navigate to="/"/>
    }
    return children
}
